import React, { Fragment } from "react";

const abrappIcon = require("../../assets/images/engajamento-abrapp.png");

const fachesfIcon = require("../../assets/images/fachesf.webp");

const equidadeGeneroIcon = require("../../assets/images/equidade-genero.png");

function Header() {
  return (
    <Fragment>
      <footer>
        <div className="contact">
          <div className="wrapper">
            <div className="certifications">
              <h3>Certificações</h3>
              <div className="box-img">
                <figure>
                  <img src={equidadeGeneroIcon} alt="Selo Equidade de Gênero" />
                </figure>
                <figure>
                  <img src={abrappIcon} alt="Selo Engajamento ABRAPP" />
                </figure>
              </div>
            </div>

            <div className="help-disk">
              <h3>TELEATENDIMENTO</h3>
              <p>
                0800 281 7533
                <br />
                629-7533 (HICOM/CHESF)
              </p>
            </div>

            <div className="menu-links">
              <nav className="menu-links-container">
                <ul id="menu-links" className="">
                  <li
                    id="menu-item-2264"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-2264"
                  >
                    <a href="http://www.previc.gov.br/">Links Úteis</a>
                    <ul className="sub-menu">
                      <li
                        id="menu-item-2262"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-2262"
                      >
                        <a href="http://www.previc.gov.br/">PREVIC</a>
                      </li>
                      <li
                        id="menu-item-2263"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-2263"
                      >
                        <a href="https://www.abrapp.org.br/">Abrapp</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <div className="bottom">
          <div className="wrapper">
            <figure>
              <img src={fachesfIcon} alt="Selo Equidade de Gênero" />
            </figure>

            <p>
              <strong>SEDE:</strong> Fachesf | Rua do Paissandu, 58 – Boa Vista
              – Recife – PE – CEP 50070-205
            </p>
            <div className="social">
              <a href="https://amorpelofuturo.com.br" target="_blank">
                <span className="dashicons dashicons-admin-comments"></span>
              </a>
              <a href="https://youtube.com/user/fachesf" target="_blank">
                <span className="dashicons dashicons-youtube"></span>
              </a>
              <a>
                <span className="dashicons dashicons-whatsapp"></span>
              </a>
              <a>
                <span className="dashicons dashicons-instagram"></span>
              </a>
              <a href="https://linkedin.com/company/fachesf" target="_blank">
                <span className="dashicons dashicons-linkedin"></span>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </Fragment>
  );
}
export default Header;
